import * as React from 'react';
import { Suggestion } from '../suggestion';
import { config } from '../../../../config';
import { Path } from '../../../..';
import { composer } from '../../../../component-decorators/composer';
import s from './apps-suggestions.scss';
import { Text } from 'wix-style-react';
import { SuggestionType } from '../../../../types/common/marketplace';
export var AppsSuggestions = composer()
    .withTranslation()
    .withBiLogger()
    .compose(function (_a) {
    var t = _a.t, apps = _a.apps, searchValue = _a.searchValue, addSelectedNode = _a.addSelectedNode, onSearchValueChange = _a.onSearchValueChange, sendSearchSearchClickBi = _a.sendSearchSearchClickBi;
    var removeSpaces = function (str) { return str && str.replace(/\s/g, ''); };
    return (React.createElement(React.Fragment, null,
        apps.length > 0 && (React.createElement("div", { className: s.appsSuggestionsTitle, "data-testid": "apps-suggestions-title" },
            React.createElement("div", { className: s.titleText },
                React.createElement(Text, { size: 'small' }, t('search.box.apps.title'))))),
        apps.map(function (app) { return (React.createElement(Suggestion, { key: removeSpaces(app.slug), suggestionKey: removeSpaces(app.slug), value: app.name, suggestionType: SuggestionType.APP, onClick: function () {
                onSearchValueChange(app.name);
                sendSearchSearchClickBi(searchValue, 'apps', app.index);
                config.goto({ path: Path.WEB_SOLUTION, slug: app.slug });
            }, icon: app.icon, teaser: app.teaser, selected: app.selected, index: app.index, addSelected: addSelectedNode })); })));
});
//# sourceMappingURL=apps-suggestions.js.map